<mwe-tariff-selection-card-ui
  [hasActions]="hasActions()"
  [processType]="processType()"
  [additionalOptionGroupName]="additionalOptionGroupName()"
  [isReadonly]="isReadonly()"
  [tariff]="tariff()"
  [lockedGroupIds]="lockedGroupIds()"
  (tariffUpdated)="onTariffUpdated($event)"
  (reloadAfterError)="onReloadAfterError()"
>
  <ng-content />
</mwe-tariff-selection-card-ui>
